module.exports = __webpack_public_path__ + "img/logo.fc61eec4.png";